<template>
  <div class="legal-page formatted-tos">
    <h1>Terms of Service</h1>
    <p><strong>Last Updated:</strong> June 28, 2025</p>

    <p>
      Please read these Terms of Service ("Terms") carefully before using the Pathtracer platform ("Service"). Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. By accessing or using the Service, you agree to be bound by these Terms.
    </p>

    <hr />

    <h3>1. Description of Service</h3>
    <p>
      Pathtracer provides advanced blockchain transaction visualizations and fund flow analysis. The Service is intended primarily for investigative, educational, and analytical purposes, assisting users in tracing cryptocurrency transactions.
    </p>

    <h3>2. Eligibility</h3>
    <ul>
      <li>Are at least 18 years of age.</li>
      <li>Have the legal capacity and authority to enter into these Terms.</li>
      <li>Will use the Service in compliance with all applicable laws and regulations.</li>
      <li>Within US or Canada</li>
    </ul>

    <h3>3. User Accounts and Access</h3>
    <p>You agree to:</p>
    <ul>
      <li>Provide accurate and complete information during registration.</li>
      <li>Maintain and promptly update your account information.</li>
      <li>Secure your login credentials and notify us immediately of any unauthorized access.</li>
      <li>Disable any VPNs or hosting while using the platform.</li>
    </ul>

    <h3>4. Acceptable Use</h3>
    <p>You agree not to misuse the Service, including but not limited to:</p>
    <ul>
      <li>Attempting unauthorized access to the Service.</li>
      <li>Using automated systems or scripts to extract data from Pathtracer without permission.</li>
      <li>Violating applicable laws or regulations.</li>
      <li>Engaging in activities that disrupt or interfere with the functionality or security of Pathtracer.</li>
    </ul>

    <h3>5. Law Enforcement and Legal Entities</h3>
    <p>
      If you represent a law enforcement agency or legal entity, you must accurately disclose this at registration. Pathtracer cooperates with valid legal requests from authorities, complying with applicable laws.
    </p>

    <h3>6. Data Privacy</h3>
    <p>
      Your privacy is important to us. Please review our
      <router-link to="/privacy" target="_blank">Privacy Policy</router-link>
      to understand how we collect, use, and safeguard your information.
    </p>

    <h3>7. Limitation of Liability</h3>
    <p>
      Pathtracer provides blockchain data visualization and analytical insights on an "as-is" basis. While we strive for accuracy, we do not guarantee the completeness or accuracy of information provided. Pathtracer shall not be liable for any direct, indirect, or consequential losses arising from your use of the Service.
    </p>

    <h3>8. Modifications to the Terms</h3>
    <p>
      We reserve the right to update or modify these Terms at any time. Changes will be posted on this page with an updated date. Your continued use of the Service following any modifications indicates your acceptance of the new Terms.
    </p>

    <h3>9. Intellectual Property</h3>
    <p>
      All content, features, and functionality of Pathtracer, including data visualizations, reports, and software, are the exclusive property of Pathtracer and are protected by applicable intellectual property laws.
    </p>

    <h3>10. Termination</h3>
    <p>
      We reserve the right to suspend or terminate your account and access to the Service, without prior notice, for any reason, including violation of these Terms.
    </p>

    <h3>11. Governing Law</h3>
    <p>
      These Terms shall be governed by and interpreted in accordance with the laws of your jurisdiction, without regard to conflict of law principles.
    </p>

    <h3>12. Contact Information</h3>
    <p>
      For questions regarding these Terms, please contact us at
      <a href="mailto:support@pathtracer.io">support@pathtracer.io</a>.
    </p>

    <p><em>By using Pathtracer, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.</em></p>
  </div>
</template>

<script>
export default {
  name: 'TermsOfService'
};
</script>

<style scoped>
.legal-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 30px 20px;
  color: #333;
  font-size: 14px;
  line-height: 1.6;
}

.legal-page h1 {
  font-size: 24px;
  margin-bottom: 16px;
}

.legal-page h3 {
  margin-top: 24px;
  font-size: 16px;
  font-weight: bold;
}

.legal-page ul {
  padding-left: 20px;
  margin: 10px 0;
}

.legal-page ul li {
  margin-bottom: 6px;
}

.legal-page a {
  color: #3498db;
  text-decoration: underline;
}

.legal-page a:hover {
  color: #2980b9;
}
</style>
